import { FaFacebookF, FaInstagram, FaTwitter, FaPhoneAlt, FaEnvelope } from "react-icons/fa";
import Image from "next/image";

export default function Topbar() {
  return (
    <header className="w-full bg-[#1f2837] text-white font-montserrat shadow-md">
      <div className="text-xs sm:text-sm">
        <div className="mx-auto px-6 lg:px-12 flex flex-col md:flex-row items-center md:justify-between py-2 gap-2 md:gap-0">
          
          {/* ✅ Logo + Slogan */}
          <div className="flex items-center gap-2 text-center md:text-left">
            <Image
              src="/topbar-logo.svg"
              alt="Topbar Logo"
              width={26}
              height={26}
              priority
            />
            <span className="text-[13px] font-medium tracking-wide">
              Монгол Улсын анхны нэгдсэн үнэлгээний платформ
            </span>
          </div>

          <div className="flex flex-col sm:flex-row items-center gap-2 sm:gap-6 text-[13px] font-medium tracking-wide">
            <div className="flex items-center gap-4 text-[11px] sm:text-xs">
              <a
                href="tel:+97696888660"
                className="flex items-center gap-1 whitespace-nowrap hover:text-gray-200 transition-colors duration-200"
              >
                <FaPhoneAlt size={12} className="text-[#577099]" />
                +976 9688 8660
              </a>
              <a
                href="mailto:chanaraas@gmail.com"
                className="flex items-center gap-1 whitespace-nowrap hover:text-gray-200 transition-colors duration-200"
              >
                <FaEnvelope size={12} className="text-[#577099]" />
                chanaraas@gmail.com
              </a>
            </div>

            <div className="flex gap-3 text-white">
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-blue-400 transition-transform duration-200 hover:scale-110"
              >
                <FaFacebookF size={15} />
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-pink-400 transition-transform duration-200 hover:scale-110"
              >
                <FaInstagram size={15} />
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-sky-400 transition-transform duration-200 hover:scale-110"
              >
                <FaTwitter size={15} />
              </a>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
